import React from 'react';

import { SearchForm, LabeledCard,
  ExtendableTable, Pagination, WithState } from '../index';

export const DataTable = ({
  id = 'dataTable',
  shouldReset,
  onPageSizeChange,
  perPage,
  reset,
  columns,
  subColumns,
  searchFields,
  formik,
  data,
  title,
  icon,
  page,
  onPageChange,
  isFailed,
  isFetching,
  headerAddition = null,
  emptyDataMessage
}) => (
  <>
    {searchFields && (
      <SearchForm
        id={ `${id}-searchForm` }
        fields={ searchFields }
        // eslint-disable-next-line no-nested-ternary
        onReset={ (formik.initialValues !== formik.values || shouldReset) ? (reset ? reset : formik.resetForm) : null }
        onSearch={ () => {
          formik.handleSubmit();
        } }
      />
    )}
    <WithState isFetching={ isFetching } isFailed={ isFailed }>
      <LabeledCard id={ `${id}-label` } icon={ icon } title={ title } headerAddition={ headerAddition }>
        <ExtendableTable
          id={ `${id}-table` }
          columns={ columns }
          subColumns={ subColumns }
          data={ data?.items }
          emptyDataMessage={ emptyDataMessage }
        />
        <br />
        <Pagination
          id={ `${id}-pagination` }
          showSizeChanger={ !!onPageSizeChange }
          onShowSizeChange={ onPageSizeChange }
          total={ data?.total }
          onChange={ onPageChange }
          current={ page }
          pageSize={ perPage || 10 }
        />
      </LabeledCard>
    </WithState>
  </>
);
